import * as Utils from "../utils/Config";
import { AuthContextModel } from "../App";
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IPatientsListing, IListingSearchParams } from "../models/IPatientsListings"
import { objectToQueryString } from "../helpers/ApiHelper";
import { IEndedListingPatient, ISearchEndedListing } from "../models/IEndedListingPatient"
import { ICareProvider } from "../models/ICareProvider";

export interface PatientModel {
    namn?: string;
    id?: string;
}

export class ListingsApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    listPatient(patientId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/listings?patientId=${patientId}`, null, success, error);
    }

    getListedPatients(searchParams: IListingSearchParams, success: (data: IPaginatedResponse<IPatientsListing[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IPatientsListing[]>(`${Utils.LIB_API_BASE_URL}/listings?${queryString}`, success, error, final);
    }

    getListedPatientsAsExcel(searchParameters: IListingSearchParams | undefined, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParameters);
        this.getFile(`${Utils.LIB_API_BASE_URL}/listings?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getListedUnlistedPatientsAsTxt(success?: () => void, error?: (message: string) => void, final?: () => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/listings?exportTxt=true`, undefined, success, error, final);
    }

    delistPatient(patientId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/listings/${patientId}/delist`, null, success, error);
    }

    getCareProviders(success: (data: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/listings/careProviders`, success, error, final)
    }

    getEndedListings(searchParams: ISearchEndedListing, success: (data: IPaginatedResponse<IEndedListingPatient[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IEndedListingPatient[]>(`${Utils.LIB_API_BASE_URL}/listings/endedListings?${queryString}`, success, error, final);
    }

    getEndedListingsAsExcel(searchParams: ISearchEndedListing, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/listings/endedListings?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getCareProvidersWithEndedListings(umbrellaCareProviderId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/listings/careProvidersWithEndedListings/${umbrellaCareProviderId}`, success, error, final);
    }

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/listings/umbrellaOgranisations`, success, error, final);
    }

    getUmbrellaOrganisationsWithActiveListings(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/listings/umbrellaOrganisationsWithActiveListings`, success, error, final);
    }

    getUmbrellaCareProvidersByUmbrellaCareProviderId(umbrellaCareProviderId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/listings/careProviders/${umbrellaCareProviderId}`, success, error, final);
    }

    getUmbrellaListingsExcelReport(fileName: string, umbrellaCareProviderId: number, success?: () => void, error?: (message: string) => void, final?: () => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/listings/umbrellaListingsExcelReport/${umbrellaCareProviderId}`, fileName, success, error, final);
    }

    getUmbrellaRevisionEndExcelReport(searchParams: IListingSearchParams, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const monthFrom = searchParams.revisionEndDateFrom ? parseInt(searchParams.revisionEndDateFrom?.getMonth().toString()) + 1 : undefined;
        const monthTo = searchParams.revisionEndDateTo ? parseInt(searchParams.revisionEndDateTo?.getMonth().toString()) + 1 : undefined;
        const queryString = `revisionEndDateFrom=${searchParams.revisionEndDateFrom?.getFullYear()}-${monthFrom}-${searchParams.revisionEndDateFrom?.getDate()}&revisionEndDateTo=${searchParams.revisionEndDateTo?.getFullYear()}-${monthTo}-${searchParams.revisionEndDateTo?.getDate()}&umbrellaCareProviderId=${searchParams.umbrellaCareProviderId}&careProviderId=${searchParams.umbrellaCareProviderId}`;
        this.getFile(`${Utils.LIB_API_BASE_URL}/listings/umbrellaRevisionEndExcelReport?${queryString}`, fileName, success, error, final);
    }
}